import moment from 'moment';
import * as types from '../../constants/actionsType'
const initialState = {
    skill: [],
    skillSet: [],
    skillsetItemsAddApiResp: '',
    skillsetAddApiResp: '',
    updateEmployeeDetailsResp: '',
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.LOAD_ALL_SKILLSET:
            //console.log('action.data', action.data);
            return {
                ...state,
                skillSet: action.data
            }
        case types.LOAD_ALL_SKILLS:
            return {
                ...state,
                skill: action.data
            }
        case types.ADD_SKILLSET:
            var skillSet = action.data;
            return {
                ...state,
                skillSet: state.skillSet.concat(skillSet)
            }
        case types.ADD_SKILLS:
            var skill = action.data;
            return {
                ...state,
                skill: state.skill.concat(skill)
            }
        case types.SUCCESS_SKILLSETITEMS_ADD:
            return {
                ...state,
                skillsetItemsAddApiResp: action.data
            }
        case types.SUCCESS_SKILLSET_ADD:
            return {
                ...state,
                skillsetAddApiResp: action.data
            }
        case types.ADD_UPDATE_EMPLOYEE_DETAILS_RESP:
            return {
                ...state,
                updateEmployeeDetailsResp: action.data
            }
        default:
            return state
    }
}
export default reducer